/* Dream Girl Studio — Join Waitlist
   Topp Level Marketing.

   The theme greys out full dates in its own dropdown and swaps dates without
   re-rendering this block. So the block carries the full variant list, and this
   script decides what to show: the red Join Waitlist button when the selected
   date is itself full, or a quiet "Is the date you want full?" link when other
   dates are full, with a "Which date?" picker inside the form.
   Everything is delegated off `document` and set up exactly once. */

(function () {
  'use strict';

  if (window.__tlmWaitlistReady) return;
  window.__tlmWaitlistReady = true;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var NO_DATE = 'No date listed';

  function root(el) { return el ? el.closest('.tlm-wl') : null; }
  function q(scope, sel) { return scope ? scope.querySelector(sel) : null; }
  function scopeOf(wl) { return wl.closest('[id^="shopify-section"]') || document; }

  /* --- which date is selected right now? -------------------------------- */

  function variantsOf(wl) {
    if (wl.__tlmVariants) return wl.__tlmVariants;
    var el = q(wl, '.tlm-wl__variants');
    try { wl.__tlmVariants = el ? JSON.parse(el.textContent) : null; } catch (e) { wl.__tlmVariants = null; }
    return wl.__tlmVariants;
  }

  /* Read the option dropdowns / radios and match "A / B / C" against the
     variant titles. Doesn't depend on the theme's own update timing. */
  function selectedFromPickers(wl, map) {
    var scope = scopeOf(wl);
    var picker = q(scope, 'variant-selects, variant-radios');
    if (!picker) return null;

    var values = [];
    var fields = picker.querySelectorAll('select, input[type="radio"]:checked');
    for (var i = 0; i < fields.length; i++) values.push(String(fields[i].value).trim());
    if (!values.length) return null;

    var title = values.join(' / ');
    for (var id in map) {
      if (Object.prototype.hasOwnProperty.call(map, id) && map[id].t === title) return id;
    }
    return null;
  }

  function selectedVariantId(wl, map) {
    var fromPickers = selectedFromPickers(wl, map);
    if (fromPickers) return fromPickers;

    var input = q(scopeOf(wl), 'form[action*="/cart/add"] input[name="id"]');
    if (input && input.value && map[input.value]) return String(input.value);

    var m = /[?&]variant=(\d+)/.exec(location.search);
    if (m && map[m[1]]) return m[1];

    return wl.getAttribute('data-variant');
  }

  var ANY = '__any__';
  var ANY_LABEL = 'Any date (the next one that opens)';

  function soldOut(map) {
    return Object.keys(map).filter(function (id) { return !map[id].a; });
  }

  /* Drop the group-size part ("8 participants/ 2 hours ...") so a date shows once. */
  function dateLabel(t) {
    return String(t || '').split(' / ').filter(function (p) { return !/participant/i.test(p); }).join(' / ') || String(t || '');
  }

  function hasRealDates(map) {
    return Object.keys(map).some(function (id) { return map[id].t && map[id].t !== 'Default Title'; });
  }

  /* The theme greys out full dates in its own dropdown, so nobody can select
     one. Build a second way in, plus a "Which date?" picker, once per block. */
  function ensureUi(wl, map) {
    if (wl.__tlmUi) return;
    wl.__tlmUi = true;

    var open = q(wl, '.tlm-wl__open');
    if (open && !q(wl, '.tlm-wl__alt')) {
      var alt = document.createElement('p');
      alt.className = 'tlm-wl__alt';
      alt.hidden = true;
      alt.appendChild(document.createTextNode('Is the date you want full? '));
      var link = document.createElement('button');
      link.type = 'button';
      link.className = 'tlm-wl__link';
      link.textContent = 'Join Waitlist';
      alt.appendChild(link);
      open.insertAdjacentElement('afterend', alt);
    }

    var form = q(wl, '.tlm-wl__form');
    var ids = soldOut(map);
    if (form && hasRealDates(map) && ids.length && !q(wl, '.tlm-wl__select')) {
      var uid = 'tlm-wl-date-' + (wl.getAttribute('data-variant') || Math.random().toString(36).slice(2));
      var field = document.createElement('div');
      field.className = 'tlm-wl__field';
      var label = document.createElement('label');
      label.className = 'tlm-wl__label';
      label.htmlFor = uid;
      label.textContent = 'Which date did you want?';
      var sel = document.createElement('select');
      sel.className = 'tlm-wl__input tlm-wl__select';
      sel.id = uid;
      sel.name = 'tlm_date';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Choose a date';
      sel.appendChild(ph);
      var seen = {};
      ids.forEach(function (id) {
        var lbl = dateLabel(map[id].t);
        if (seen[lbl]) return; // private workshops: one entry per date, not per group size
        seen[lbl] = true;
        var o = document.createElement('option');
        o.value = id;
        o.textContent = lbl;
        sel.appendChild(o);
      });
      var any = document.createElement('option');
      any.value = ANY;
      any.textContent = ANY_LABEL;
      sel.appendChild(any);
      field.appendChild(label);
      field.appendChild(sel);
      form.insertBefore(field, form.firstChild);
    }
  }

  function setIntro(wl, primary) {
    var intro = q(wl, '.tlm-wl__intro');
    if (!intro || !intro.firstChild || intro.firstChild.nodeType !== 3) return;
    var text = primary
      ? 'This one is full. Leave your name and Seneca will email you as soon as another one is scheduled. '
      : 'Tell Seneca which date you wanted and she will email you as soon as another one is scheduled. ';
    if (intro.firstChild.nodeValue !== text) intro.firstChild.nodeValue = text;
  }

  function resetPanel(wl) {
    var open = q(wl, '.tlm-wl__open');
    var panel = q(wl, '.tlm-wl__panel');
    var done = q(wl, '.tlm-wl__done');
    var err = q(wl, '.tlm-wl__error');
    var sub = q(wl, '.tlm-wl__submit');
    wl.__tlmOpen = false;
    if (open) open.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    if (done) done.hidden = true;
    if (err) { err.hidden = true; err.textContent = ''; }
    if (sub) {
      sub.disabled = false;
      if (sub.textContent !== 'Add me to the list') sub.textContent = 'Add me to the list';
    }
  }

  function sync(wl) {
    var map = variantsOf(wl);
    if (!map) return;

    var id = selectedVariantId(wl, map);
    if (!id || !map[id]) return;

    var v = map[id];
    var date = (!v.t || v.t === 'Default Title') ? NO_DATE : v.t;
    var changed = wl.getAttribute('data-variant') !== String(id);

    wl.setAttribute('data-variant', id);
    wl.setAttribute('data-date', date);

    var base = wl.getAttribute('data-base-url');
    if (base) wl.setAttribute('data-url', base + '?variant=' + id);

    ensureUi(wl, map);
    if (changed) resetPanel(wl);

    /* With a "Which date?" picker the heading shows just the class name. */
    var label = q(wl, '.tlm-wl__which-date');
    var labelText = (q(wl, '.tlm-wl__select') || date === NO_DATE) ? '' : ' — ' + date;
    if (label && label.textContent !== labelText) label.textContent = labelText;

    var anyFull = soldOut(map).length > 0;
    var primary = !v.a;
    wl.hidden = !anyFull;
    wl.setAttribute('data-mode', primary ? 'primary' : 'alt');
    setIntro(wl, primary);

    /* Buy with Shop still renders on a full date and leads nowhere. */
    var pay = q(scopeOf(wl), '.shopify-payment-button');
    if (pay && pay.hidden !== primary) pay.hidden = primary;

    var openBtn = q(wl, '.tlm-wl__open');
    var alt = q(wl, '.tlm-wl__alt');
    var isOpen = !!wl.__tlmOpen;
    if (openBtn) openBtn.hidden = isOpen || !primary;
    if (alt) alt.hidden = isOpen || primary;
  }

  /* --- is this sitting on a solid red background? ---------------------- */

  function isRed(rgb) {
    var m = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/.exec(rgb || '');
    if (!m) return false;
    var r = +m[1], g = +m[2], b = +m[3];
    return r > 110 && r < 210 && g < 70 && b < 70;
  }

  function checkBackdrop(wl) {
    var node = wl.parentElement, depth = 0;
    while (node && node !== document.body && depth < 10) {
      var bg = getComputedStyle(node).backgroundColor;
      if (bg && bg !== 'transparent' && !/rgba\(0,\s*0,\s*0,\s*0\)/.test(bg)) {
        if (isRed(bg)) wl.classList.add('tlm-wl--inverse');
        return;
      }
      node = node.parentElement;
      depth++;
    }
  }

  function scan() {
    var list = document.querySelectorAll('.tlm-wl');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].hasAttribute('data-tlm-scanned')) {
        list[i].setAttribute('data-tlm-scanned', '1');
        checkBackdrop(list[i]);
      }
      sync(list[i]);
    }
  }

  /* --- open the panel --------------------------------------------------- */

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('.tlm-wl__open, .tlm-wl__link') : null;
    if (!btn) return;
    ev.preventDefault();

    var wl = root(btn);
    if (!wl) return;
    sync(wl);

    var panel = q(wl, '.tlm-wl__panel');
    if (!panel) return;

    wl.__tlmOpen = true;
    panel.hidden = false;
    var openBtn = q(wl, '.tlm-wl__open');
    var alt = q(wl, '.tlm-wl__alt');
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'true'); openBtn.hidden = true; }
    if (alt) alt.hidden = true;

    var sel = q(wl, '.tlm-wl__select');
    if (sel) sel.value = wl.getAttribute('data-mode') === 'primary' ? (wl.getAttribute('data-variant') || '') : '';

    var first = sel && !sel.value ? sel : q(panel, '[name="tlm_name"]');
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
  });

  /* --- submit ----------------------------------------------------------- */

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.classList || !form.classList.contains('tlm-wl__form')) return;

    ev.preventDefault();

    var wl = root(form);
    if (!wl) return;
    sync(wl);

    var endpoint = wl.getAttribute('data-endpoint') || '';
    var errBox = q(wl, '.tlm-wl__error');
    var submit = q(wl, '.tlm-wl__submit');
    var nameEl = q(wl, '[name="tlm_name"]');
    var mailEl = q(wl, '[name="tlm_email"]');
    var hpEl = q(wl, '[name="tlm_company"]');

    function fail(msg, field) {
      if (errBox) { errBox.textContent = msg; errBox.hidden = false; }
      if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
    }
    function clearErr() {
      if (errBox) { errBox.hidden = true; errBox.textContent = ''; }
      if (nameEl) nameEl.removeAttribute('aria-invalid');
      if (mailEl) mailEl.removeAttribute('aria-invalid');
      var d = q(wl, '.tlm-wl__select');
      if (d) d.removeAttribute('aria-invalid');
    }

    clearErr();

    if (hpEl && hpEl.value) return; // bot

    var name = nameEl ? nameEl.value.trim() : '';
    var email = mailEl ? mailEl.value.trim() : '';

    var chosenDate = wl.getAttribute('data-date') || '';
    var chosenUrl = wl.getAttribute('data-url') || '';
    var dateEl = q(wl, '.tlm-wl__select');
    if (dateEl) {
      if (!dateEl.value) return fail('Please choose the date you wanted.', dateEl);
      var vmap = variantsOf(wl) || {};
      var base = wl.getAttribute('data-base-url') || '';
      if (dateEl.value === ANY) {
        chosenDate = ANY_LABEL;
        chosenUrl = base;
      } else if (vmap[dateEl.value]) {
        chosenDate = dateLabel(vmap[dateEl.value].t);
        chosenUrl = base ? base + '?variant=' + dateEl.value : chosenUrl;
      }
    }

    if (name.length < 2) return fail('Please add your name so Seneca knows who to reach.', nameEl);
    if (!EMAIL.test(email)) return fail('That email address does not look quite right.', mailEl);

    if (!endpoint) {
      return fail('The waitlist is not connected yet. Please call the studio on 773-597-7167.');
    }

    if (submit) { submit.disabled = true; submit.textContent = 'Adding you…'; }

    var payload = {
      secret: wl.getAttribute('data-secret') || '',
      name: name,
      email: email,
      className: wl.getAttribute('data-class') || '',
      classDate: chosenDate,
      productUrl: chosenUrl
    };

    function done() {
      var panel = q(wl, '.tlm-wl__panel');
      var doneBox = q(wl, '.tlm-wl__done');
      if (panel) panel.hidden = true;
      if (doneBox) {
        doneBox.hidden = false;
        doneBox.setAttribute('tabindex', '-1');
        try { doneBox.focus({ preventScroll: true }); } catch (e) {}
      }
    }

    function recover(msg) {
      if (submit) { submit.disabled = false; submit.textContent = 'Add me to the list'; }
      fail(msg || 'Something went wrong on our end. Please try again, or call 773-597-7167.');
    }

    /* text/plain keeps this a "simple" request, so the browser skips the
       CORS preflight that Apps Script redirects would otherwise fail. */
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      redirect: 'follow'
    })
      .then(function (res) { return res.json().catch(function () { return { ok: true }; }); })
      .then(function (data) {
        if (data && data.ok === false) {
          recover(
            data.error === 'email_invalid'
              ? 'That email address does not look quite right.'
              : 'We could not save that just now. Please try again, or call 773-597-7167.'
          );
          return;
        }
        done();
      })
      .catch(function () {
        /* Opaque or blocked response. Retry once without reading the reply —
           the row still gets written. */
        fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        }).then(done).catch(function () { recover(); });
      });
  });

  /* --- clear an error as soon as they fix it ---------------------------- */

  function clearFieldError(ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('.tlm-wl__input') : null;
    if (!el) return;
    var wl = root(el);
    if (!wl) return;
    el.removeAttribute('aria-invalid');
    var err = q(wl, '.tlm-wl__error');
    if (err && !err.hidden) { err.hidden = true; err.textContent = ''; }
  }

  document.addEventListener('input', clearFieldError);
  document.addEventListener('change', clearFieldError);

  /* --- stay in step with the date picker -------------------------------- */

  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.closest || !t.closest('variant-selects, variant-radios')) return;
    scan();
    setTimeout(scan, 300);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('popstate', function () { setTimeout(scan, 50); });

  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; scan(); }, 120);
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
